import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from '../../../utils/logger';
import { Loader, SectionTitle } from '../../shared/components';
import { getAllNewsArticles } from '../news.service';
import NewsArticleCard from './NewsArticleCard';
import NewsEntryModal from './NewsEntryModal';

export default function NewsEditorWidget() {
  const [loading, setLoading] = useState(false);
  const [articles, setArticles] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [entryMode, setEntryMode] = useState('add');
  const [activeNews, setActiveNews] = useState(null);

  const fetchAllNewsArticles = useCallback(async () => {
    setLoading(true);
    setFormOpen(false);
    setActiveNews(null);
    try {
      const newsData = await getAllNewsArticles();
      setArticles(newsData);
    } catch (err) {
      toast.error(logError({ message: err }));
      setArticles([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllNewsArticles();
  }, [fetchAllNewsArticles]);

  return (
    <>
      <Stack direction='column' gap={5}>
        <SectionTitle
          title='News billboard'
          action={
            <button
              type='button'
              className='btn cta-outlined-btn'
              onClick={() => {
                setEntryMode('add');
                setFormOpen(true);
              }}
            >
              Add news article
            </button>
          }
        />
        <Stack
          direction='column'
          gap={2}
          sx={{ maxHeight: '60vh', overflowY: 'auto', scrollbarGutter: 'stable', pr: 1 }}
        >
          {loading ? (
            <Loader />
          ) : articles?.length === 0 ? (
            <Alert severity='info' sx={{ fontStyle: 'italic' }}>
              No news articles available
            </Alert>
          ) : (
            articles.map((article, index) => (
              <NewsArticleCard
                key={index}
                article={article}
                index={index}
                onEdit={() => {
                  setEntryMode('edit');
                  setActiveNews(article);
                  setFormOpen(true);
                }}
                onDelete={fetchAllNewsArticles}
              />
            ))
          )}
        </Stack>
      </Stack>
      <NewsEntryModal
        open={formOpen}
        onClose={() => setFormOpen(false)}
        mode={entryMode}
        article={activeNews}
        onSubmit={fetchAllNewsArticles}
      />
    </>
  );
}
